window.addEventListener("load", function() {
    let products = document.querySelectorAll('.product-list-item');

    if (!products) return;

    var observer = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
            let listItem = mutation.target;
            let quickView = listItem.querySelector(".sca-qv-button-wrap");
            let options = listItem.querySelector(".product-item-options");

            if (!quickView) return;

            options.insertBefore(quickView, options.firstElementChild);

            if (listItem.classList.contains("sca-qv-image")) {
                listItem.classList.remove("sca-qv-image");
            }
        });
    });

    var config = { attributes: true, childList: true, characterData: true };

    for (let i = 0; i < products.length; i++) {
        let product = products[i];
        let links = product.querySelectorAll("a");

        for (let j = 0; j < links.length; j++) {
            let link = links[j];

            link.addEventListener("click", function() {
                if (document.documentElement.classList.contains("touch")) {
                    location.href = link.getAttribute("href");
                }
            });
        }

        observer.observe(product, config);
    }
});


$(document).ready(function(){
  
  // home video modal
  var home_modal_iframe = $(".home-modal-video iframe")[0];
  var home_modal_video_player = $f(home_modal_iframe);
  
  $('.home-video-poster').click(function(){
    if(!$('body').hasClass("active_homevideo-modal")){
      $('body').toggleClass("active_homevideo-modal");
      $(".home-modal-video iframe")[0].src += "&autoplay=1";
    }
  });
  $('body').click(function(e){
    if( $(e.target).is('.active_homevideo-modal') ) {
      e.preventDefault();
      $(this).removeClass('active_homevideo-modal');
      home_modal_video_player.api('pause');
    }
  });
  $('.home-modal-video svg').click(function(e){
    $('body').toggleClass("active_homevideo-modal");
    home_modal_video_player.api('pause');
  });
  
});

function setHeaderHeight() {
  const siteHeader = document.querySelector("header.header")

  if (siteHeader) {
    document.documentElement.style.setProperty("--header-height", `${siteHeader.clientHeight}px`);
  }
}

$(document).ready(setHeaderHeight)
$(window).resize(setHeaderHeight)
